import { render, staticRenderFns } from "./deleteFloorShare.vue?vue&type=template&id=5ac0be1e&scoped=true"
import script from "./deleteFloorShare.vue?vue&type=script&lang=js"
export * from "./deleteFloorShare.vue?vue&type=script&lang=js"
import style0 from "./deleteFloorShare.vue?vue&type=style&index=0&id=5ac0be1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac0be1e",
  null
  
)

export default component.exports